import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getKycList,
  mytradePreference,
  priceExchangeRate,
  tradePreferenceStore,
  tradePrefrenceOptions,
  userService,
} from "./userService";
import { setShowKycWarning } from "../buyer/uiSlice";
import { data } from "react-router-dom";

// View profile
export const fetchUserProfile = createAsyncThunk(
  "buyer/fetchProfile",
  async (_, thunkAPI) => {
    try {
      const response = await userService.getProfile();
      // console.log("User Profile:", response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to fetch profile",
      );
    }
  },
);

// Update profile
export const updateUserProfile = createAsyncThunk(
  "buyer/updateProfile",
  async (profileData, thunkAPI) => {
    console.log("Response Update data:", profileData);
    try {
      const response = await userService.updateProfile(profileData);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to update profile",
      );
    }
  },
);

//View Addresses
export const fetchUserAddresses = createAsyncThunk(
  "buyer/fetchAddresses",
  async (addressData, thunkAPI) => {
    try {
      const response = await userService.getAddressList(addressData);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to fetch address list",
      );
    }
  },
);

// Update profile
export const updateUserAddress = createAsyncThunk(
  "buyer/updateAddress",
  async (addressData, thunkAPI) => {
    try {
      const response = await userService.updateAddress(addressData);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to update address",
      );
    }
  },
);

// Change password
export const changeUserPassword = createAsyncThunk(
  "buyer/changePassword",
  async (passwordData, thunkAPI) => {
    try {
      const response = await userService.changePassword(passwordData);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to change password",
      );
    }
  },
);

// Upload KYC
export const uploadUserKyc = createAsyncThunk(
  "buyer/uploadKyc",
  async (formData, thunkAPI) => {
    try {
      const response = await userService.uploadKyc(formData);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message || "Failed to upload KYC");
    }
  },
);

// Get KYC list
export const fetchUserKycList = createAsyncThunk(
  "user/fetchUserKycList",
  async (_, thunkAPI) => {
    try {
      const kyc = await getKycList();
      console.log("API DOCUMENTS:", kyc);
      const state = thunkAPI.getState();
      const isKycApproved = state.auth?.user?.kyc_verified === 1;

      if (!isKycApproved) {
        thunkAPI.dispatch(
          setShowKycWarning("Complete your KYC for seamless access."),
        );
      }

      // Normalize: API may return an array, a single object, or null
      if (!kyc) return [];                          // null/undefined → empty
      if (Array.isArray(kyc)) return kyc.filter(Boolean); // already array → clean it
      return [kyc];                                  // single object → wrap it

    } catch (error) {
      return thunkAPI.rejectWithValue("Failed to fetch KYC list");
    }
  },
);

// Get notification list
export const getNotificationList = createAsyncThunk(
  "user/getNotificationList",
  async (_, thunkAPI) => {
    try {
      const response = await userService.getNotificationList();
      // console.log('Response:',response.data)
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to fetch Notification list",
      );
    }
  },
);

// Mark notification as read
export const notificationsMarkRead = createAsyncThunk(
  "user/notificationsMarkRead",
  async (id, thunkAPI) => {
    try {
      return await userService.notificationsMarkRead(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to mark notification as read",
      );
    }
  },
);

// Clear all notifications
export const notificationsClearAll = createAsyncThunk(
  "user/notificationsClearAll",
  async (_, thunkAPI) => {
    try {
      return await userService.notificationsClearAll();
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to clear all notification",
      );
    }
  },
);

// Get available trade preference options
export const fetchTradePreferenceOptions = createAsyncThunk(
  "user/fetchTradePreferenceOptions",
  async (_, thunkAPI) => {
    try {
      const response = await tradePrefrenceOptions();
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to fetch trade preference options",
      );
    }
  },
);

// Store/Update user trade preference
export const saveTradePreference = createAsyncThunk(
  "user/saveTradePreference",
  async (data, thunkAPI) => {
    try {
      // console.log("Dispatching saveTradePreference with:", data);
      const response = await tradePreferenceStore(data);
      // console.log("saveTradePreference success:", response.data);
      return response.data;
    } catch (error) {
      console.error(
        "saveTradePreference failed:",
        error.response || error.message,
      );
      return thunkAPI.rejectWithValue(
        error.message || "Failed to save trade preference",
      );
    }
  },
);

// Get logged-in user's trade preferences
export const fetchMyTradePreference = createAsyncThunk(
  "user/fetchMyTradePreference",
  async (_, thunkAPI) => {
    try {
      const response = await mytradePreference();
      console.log("fetchMyTradePreference:", response);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to fetch my trade preference",
      );
    }
  },
);

//Blogs Categories
export const getBlogsCategories = createAsyncThunk(
  "user/getBlogsCategories",
  async (_, thunkAPI) => {
    try {
      const response = await userService.blogsCategories();
      // console.log("Blogs categories:", response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to fetch blogs categories",
      );
    }
  },
);

//Blogs List
export const getBlogsList = createAsyncThunk(
  "user/getBlogsList",
  async (_, thunkAPI) => {
    try {
      const response = await userService.blogsList();
      // console.log("Blogs list:", response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to fetch blogs list",
      );
    }
  },
);

//Blogs by Category
export const getBlogsByCategory = createAsyncThunk(
  "user/getBlogsByCategory",
  async (id, thunkAPI) => {
    try {
      const response = await userService.blogsByCategory(id);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to fetch blogs by category",
      );
    }
  },
);

//Blog Detail by SLug
export const getBlogDetailBySlug = createAsyncThunk(
  "user/getBlogDetailBySlug",
  async (slug, thunkAPI) => {
    try {
      const response = await userService.blogDetailBySlug(slug);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to fetch blog detail by slug",
      );
    }
  },
);

//Commom Pages
export const getCommonPages = createAsyncThunk(
  "user/getCommonPages",
  async (_, thunkAPI) => {
    try {
      const response = await userService.commonPages();
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to fetch common pages",
      );
    }
  },
);

//Page Detail by Slug
export const getPageDetailBySlug = createAsyncThunk(
  "user/getPageDetailBySlug",
  async (slug, thunkAPI) => {
    try {
      const response = await userService.pageDetailBySlug(slug);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to fetch page detail by slug",
      );
    }
  },
);

//Site Map URLs
export const getSiteMapUrls = createAsyncThunk(
  "user/getsSiteMapUrls",
  async (_, thunkAPI) => {
    try {
      const response = await userService.siteMapUrls();
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to fetch site map URLs",
      );
    }
  },
);

//Footer Links
export const getFooterLinks = createAsyncThunk(
  "user/getFooterLinks",
  async (_, thunkAPI) => {
    try {
      const response = await userService.footerLinks();
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to fetch footer links",
      );
    }
  },
);

// Price Exchnage Rate
export const getPriceExchangeRate = createAsyncThunk(
  "user/getPriceExchangeRate",
  async ({ currency, unit }, thunkAPI) => {
    try {
      console.log("Args received in thunk:", { currency, unit });
      const response = await userService.priceExchangeRate(currency, unit);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to fetch price exchange rate",
      );
    }
  },
);

//News List
export const getNewsList = createAsyncThunk(
  "user/getNewsList",
  async (_, thunkAPI) => {
    try {
      const response = await userService.news();
      console.log("News List:", response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to fetch news list",
      );
    }
  },
);

// Ai Edit Image
export const editImage = createAsyncThunk(
  "user/editImage",
  async (formData, thunkAPI) => {
    try {
      const response = await userService.editImage(formData);
      console.log("Data sent to editImage thunk:", formData);
      console.log("Response from editImage thunk:", response);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message || "Failed to edit image");
    }
  },
);

export const marketCharts = createAsyncThunk(
  "user/marketCharts",
  async (data, thunkAPI) => {
    try {
      const response = await userService.charts(data);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to fetch market charts",
      );
    }
  },
);

export const chatCreation = createAsyncThunk(
  "user/chatCreation",
  async (data, thunkAPI) => {
    try {
      const response = await userService.chatCreation(data);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to create new chat",
      );
    }
  },
);

export const sendMessage = createAsyncThunk(
  "user/sendMessage",
  async (data, thunkAPI) => {
    try {
      const response = await userService.sendMessage(data);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to send message",
      );
    }
  },
);

export const chatMessages = createAsyncThunk(
  "user/chatMessages",
  async (id, thunkAPI) => {
    try {
      const response = await userService.chatMessages(id);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to send message",
      );
    }
  },
);

export const chatThreads = createAsyncThunk(
  "user/chatThreads",
  async (_, thunkAPI) => {
    try {
      const response = await userService.chatThreads();
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to chat threads",
      );
    }
  },
);

export const markAsRead = createAsyncThunk(
  "user/markAsRead",
  async (id, thunkAPI) => {
    try {
      const response = await userService.markAsRead(id);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to mark message as read",
      );
    }
  },
);

export const typing = createAsyncThunk("user/typing", async (id, thunkAPI) => {
  try {
    const response = await userService.typing(id);
    return response;
  } catch (error) {
    return thunkAPI.rejectWithValue(
      error.message || "Failed to read the typing",
    );
  }
});

export const unreadCount = createAsyncThunk(
  "user/unreadCount",
  async (_, thunkAPI) => {
    try {
      const response = await userService.unreadCount();
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to show unread message count",
      );
    }
  },
);

export const dispute = createAsyncThunk(
  "user/dispute",
  async (id, thunkAPI) => {
    try {
      const response = await userService.dispute(id);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to create a dispute",
      );
    }
  },
);

//Chat Support Creation
export const chatSupportCreation = createAsyncThunk(
  "user/chatSupportCreation",
  async (data, thunkAPI) => {
    try {
      const response = await userService.chatSupportCreation(data);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to create new chat",
      );
    }
  },
);

//Send Support Creation
export const sendSupportMessage = createAsyncThunk(
  "user/sendSupportMessage",
  async (data, thunkAPI) => {
    try {
      const response = await userService.sendSupportMessage(data);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to send message",
      );
    }
  },
);

//Chat Support Messages
export const chatSupportMessages = createAsyncThunk(
  "user/chatSupportMessages",
  async (id, thunkAPI) => {
    try {
      const response = await userService.chatSupportMessages(id);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to send message",
      );
    }
  },
);

//Chat Support Threads
export const chatSupportThreads = createAsyncThunk(
  "user/chatSupportThreads",
  async (_, thunkAPI) => {
    try {
      const response = await userService.chatSupportThreads();
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to chat threads",
      );
    }
  },
);

//Mark Support As Read
export const markSupportAsRead = createAsyncThunk(
  "user/markSupportAsRead",
  async (id, thunkAPI) => {
    try {
      const response = await userService.markSupportAsRead(id);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to mark message as read",
      );
    }
  },
);

//Close Support Chat
export const closeSupportChat = createAsyncThunk(
  "user/closeSupportChat",
  async (id, thunkAPI) => {
    try {
      const response = await userService.closeSupportChat(id);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to mark message as read",
      );
    }
  },
);

//Switch User Role
export const switchRole = createAsyncThunk(
  "user/switchRole",
  async (data, thunkAPI) => {
    try {
      const response = await userService.switchRole(data);
      console.log("Switch Role Response:", response);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to switch user role",
      );
    }
  },
);

//Verify Role Otp
export const verifyRoleOtp = createAsyncThunk(
  "user/verifyRoleOtp",
  async (data, thunkAPI) => {
    try {
      const response = await userService.verifyRoleOtp(data);
      console.log("Verify Role Otp Response:", response);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.message || "Failed to verify role OTP",
      );
    }
  },
);

const userSlice = createSlice({
  name: "user",
  initialState: {
    profile: null,
    addresses: [],
    kycList: [],
    notifications: [],
    blogs: [],
    blogsCategories: [],
    blogDetail: null,
    commonPages: [],
    pageDetail: null,
    siteMapUrl: null,
    footerLinks: [],
    priceExchangeRate: [],
    editImageResult: null,
    chartData: null,
    createChatData: null,
    sendMessageData: null,
    chatMessagesData: [],
    chatThreadsData: [],
    markAsReadData: null,
    typingData: null,
    unreadCountData: 0,
    disputeData: null,
    createSupportChatData: null,
    sendSupportMessageData: null,
    chatSupportMessagesData: [],
    chatSupportThreadsData: [],
    markSupportAsReadData: null,
    closeSupportData: null,
    roleSwitch: null,
    newsData: [],

    profileLoading: false,
    profileError: null,
    profileSuccess: null,

    addressLoading: false,
    addressError: null,
    addressSuccess: null,

    passwordLoading: false,
    passwordError: null,
    passwordSuccess: null,

    kycLoading: false,
    kycError: null,
    kycSuccess: null,

    notificationLoading: false,
    notificationError: null,
    notificationSuccess: null,

    tradeLoading: false,
    tradeError: null,
    tradeSuccess: null,
    myPreference: null,

    blogLoading: false,
    blogError: null,
    blogSuccess: null,

    siteMapUrlLoading: false,
    siteMapUrlError: null,
    siteMapUrlSuccess: null,

    footerLinksLoading: false,
    footerLinksError: null,
    footerLinksSuccess: null,

    priceExchangeRateLoading: false,
    priceExchangeRateError: null,
    priceExchangeRateSuccess: null,

    editImageLoading: false,
    editImageError: null,
    editImageSuccess: null,

    chartLoading: false,
    chartError: null,
    chartSuccess: null,

    newsLoading: false,
    newsError: null,
    newsSuccess: null,

    createChatLoading: false,
    createChatError: null,
    createChatSuccess: null,

    sendMessageLoading: false,
    sendMessageError: null,
    sendMessageSuccess: null,

    chatMessagesLoading: false,
    chatMessagesError: null,
    chatMessagesSuccess: null,

    chatThreadsLoading: false,
    chatThreadsError: null,
    chatThreadsSuccess: null,

    markAsReadLoading: false,
    markAsReadError: null,
    markAsReadSuccess: null,

    typingLoading: false,
    typingError: null,
    typingSuccess: null,

    unreadCountLoading: false,
    unreadCountError: null,
    unreadCountSuccess: null,

    disputeLoading: false,
    disputeError: null,
    disputeSuccess: null,

    createSupportChatLoading: false,
    createSupportChatError: null,
    createSupportChatSuccess: null,

    sendSupportMessageLoading: false,
    sendSupportMessageError: null,
    sendSupportMessageSuccess: null,

    chatSupportMessagesLoading: false,
    chatSupportMessagesError: null,
    chatSupportMessagesSuccess: null,

    chatSupportThreadsLoading: false,
    chatSupportThreadsError: null,
    chatSupportThreadsSuccess: null,

    markSupportAsReadLoading: false,
    markSupportAsReadError: null,
    markSupportAsReadSuccess: null,

    closeSupportLoading: false,
    closeSupportError: null,
    closeSupportSuccess: null,

    roleSwitchLoading: false,
    roleSwitchError: null,
    roleSwitchSuccess: null,

    verifyRoleOtpLoading: false,
    verifyRoleOtpError: null,
    verifyRoleOtpSuccess: null,
  },
  reducers: {
    clearBuyerMessages: (state) => {
      state.profileError = null;
      state.profileSuccess = null;

      state.addressError = null;
      state.addressSuccess = null;

      state.passwordError = null;
      state.passwordSuccess = null;

      state.kycError = null;
      state.kycSuccess = null;

      state.notificationError = null;
      state.notificationSuccess = null;

      state.tradeError = null;
      state.tradeSuccess = null;

      state.blogError = null;
      state.blogSuccess = null;

      state.siteMapUrlError = null;
      state.siteMapUrlSuccess = null;

      state.footerLinksError = null;
      state.footerLinksSuccess = null;

      state.priceExchangeRateError = null;
      state.priceExchangeRateSuccess = null;

      state.editImageError = null;
      state.editImageSuccess = null;
      state.editImageResult = null;

      state.chartError = null;
      state.chartSuccess = null;

      state.newsError = null;
      state.newsSuccess = null;

      state.createChatError = null;
      state.createChatSuccess = null;

      state.sendMessageError = null;
      state.sendMessageSuccess = null;

      state.chatMessagesError = null;
      state.chatMessagesSuccess = null;

      state.chatThreadsError = null;
      state.chatThreadsSuccess = null;

      state.markAsReadError = null;
      state.markAsReadSuccess = null;

      state.typingError = null;
      state.typingSuccess = null;

      state.unreadCountError = null;
      state.unreadCountSuccess = null;

      state.disputeError = null;
      state.disputeSuccess = null;

      state.createSupportChatError = null;
      state.createSupportChatSuccess = null;

      state.sendSupportMessageError = null;
      state.sendSupportMessageSuccess = null;

      state.chatSupportMessagesError = null;
      state.chatSupportMessagesSuccess = null;

      state.chatSupportThreadsError = null;
      state.chatSupportThreadsSuccess = null;

      state.markSupportAsReadError = null;
      state.markSupportAsReadSuccess = null;

      state.closeSupportError = null;
      state.closeSupportSuccess = null;

      state.roleSwitchError = null;
      state.roleSwitchSuccess = null;

      state.verifyRoleOtpError = null;
      state.verifyRoleOtpSuccess = null;
    },
    clearUserProfile: (state) => {
      state.profile = null;
      state.myPreference = [];
      state.tradeOptions = [];
      // optionally reset any other user-specific state
      state.editImageError = null;
      state.editImageSuccess = null;
      state.editImageResult = null;
    },
    setCreateSupportChatData: (state, action) => {
      state.createSupportChatData = action.payload;
    },
    resetAddressStatus: (state) => {
      state.addressSuccess = false;
      state.addressError = null;
    },
    addSupportMessage: (state, action) => {
      const { chat_id, message } = action.payload;

      const thread = state.chatSupportThreadsData.find((t) => t.id === chat_id);

      if (thread) {
        if (!thread.messages) thread.messages = [];
        thread.messages.push(message);
      } else if (state.createSupportChatData?.id === chat_id) {
        if (!state.createSupportChatData.messages)
          state.createSupportChatData.messages = [];
        state.createSupportChatData.messages.push(message);
      }
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Profile
      // Profile
      .addCase(fetchUserProfile.pending, (state) => {
        state.profileLoading = true;
        state.profileError = null;
        state.profileSuccess = null;
      })
      .addCase(fetchUserProfile.fulfilled, (state, action) => {
        state.profileLoading = false;
        state.profile = action.payload;
      })
      .addCase(fetchUserProfile.rejected, (state, action) => {
        state.profileLoading = false;
        state.profileError = action.payload;
      })

      .addCase(updateUserProfile.pending, (state) => {
        state.profileLoading = true;
        state.profileError = null;
        state.profileSuccess = null;
      })
      .addCase(updateUserProfile.fulfilled, (state, action) => {
        state.profileLoading = false;
        state.profile = action.payload;
        state.profileSuccess = "Profile updated successfully";
      })
      .addCase(updateUserProfile.rejected, (state, action) => {
        state.profileLoading = false;
        state.profileError = action.payload;
      })

      // Address
      .addCase(fetchUserAddresses.pending, (state) => {
        state.addressLoading = true;
        state.addressError = null;
        state.addressSuccess = null;
      })
      .addCase(fetchUserAddresses.fulfilled, (state, action) => {
        state.addressLoading = false;
        state.addresses = action.payload;
      })
      .addCase(fetchUserAddresses.rejected, (state, action) => {
        state.addressLoading = false;
        state.addressError = action.payload;
      })

      .addCase(updateUserAddress.pending, (state) => {
        state.addressLoading = true;
        state.addressError = null;
        state.addressSuccess = null;
      })
      .addCase(updateUserAddress.fulfilled, (state, action) => {
        state.addressLoading = false;
        state.addressSuccess = "Address updated successfully";
      })
      .addCase(updateUserAddress.rejected, (state, action) => {
        state.addressLoading = false;
        state.addressError = action.payload;
      })

      // Password
      .addCase(changeUserPassword.pending, (state) => {
        state.passwordLoading = true;
        state.passwordError = null;
        state.passwordSuccess = null;
      })
      .addCase(changeUserPassword.fulfilled, (state) => {
        state.passwordLoading = false;
        state.passwordSuccess = "Password changed successfully";
      })
      .addCase(changeUserPassword.rejected, (state, action) => {
        state.passwordLoading = false;
        state.passwordError = action.payload;
      })

      // KYC Upload
      .addCase(uploadUserKyc.pending, (state) => {
        state.kycLoading = true;
        state.kycError = null;
        state.kycSuccess = null;
      })
      .addCase(uploadUserKyc.fulfilled, (state) => {
        state.kycLoading = false;
        state.kycSuccess = "KYC uploaded successfully";
      })
      .addCase(uploadUserKyc.rejected, (state, action) => {
        state.kycLoading = false;
        state.kycError = action.payload;
      })

      // KYC List
      .addCase(fetchUserKycList.pending, (state) => {
        state.kycLoading = true;
        state.kycError = null;
        state.kycSuccess = null;
      })
      .addCase(fetchUserKycList.fulfilled, (state, action) => {
        state.kycLoading = false;
        const kyc = action.payload?.data?.kyc;

        state.kycList = action.payload;
      })
      .addCase(fetchUserKycList.rejected, (state, action) => {
        state.kycLoading = false;
        state.kycError = action.payload;
      })

      // Get notification list
      .addCase(getNotificationList.pending, (state) => {
        state.notificationLoading = true;
        state.notificationError = null;
        state.notificationSuccess = null;
      })
      .addCase(getNotificationList.fulfilled, (state, action) => {
        state.notificationLoading = false;
        state.notifications = action.payload;
      })
      .addCase(getNotificationList.rejected, (state, action) => {
        state.notificationLoading = false;
        state.notificationError = action.payload;
      })

      // Mark notification as read
      .addCase(notificationsMarkRead.pending, (state) => {
        state.notificationLoading = true;
        state.notificationError = null;
        state.notificationSuccess = null;
      })
      .addCase(notificationsMarkRead.fulfilled, (state, action) => {
        state.notificationLoading = false;
        state.notificationSuccess = "Notification marked as read";
        // Optionally update the notification in state.list here
        const id = action.meta.arg; // The id you passed to the thunk
        const notification = state.notifications.find((n) => n.id === id);
        if (notification) {
          notification.is_read = true;
        }
      })
      .addCase(notificationsMarkRead.rejected, (state, action) => {
        state.notificationLoading = false;
        state.notificationError = action.payload;
      })

      // Clear all notifications
      .addCase(notificationsClearAll.pending, (state) => {
        state.notificationLoading = true;
        state.notificationError = null;
        state.notificationSuccess = null;
      })
      .addCase(notificationsClearAll.fulfilled, (state, action) => {
        state.notificationLoading = false;
        state.notificationSuccess = "All notifications cleared";
        state.notifications = [];
      })
      .addCase(notificationsClearAll.rejected, (state, action) => {
        state.notificationLoading = false;
        state.notificationError = action.payload;
      })

      // Trade Preference - Get Options
      .addCase(fetchTradePreferenceOptions.pending, (state) => {
        state.tradeLoading = true;
        state.tradeError = null;
      })
      .addCase(fetchTradePreferenceOptions.fulfilled, (state, action) => {
        state.tradeLoading = false;
        state.tradeOptions = action.payload;
      })
      .addCase(fetchTradePreferenceOptions.rejected, (state, action) => {
        state.tradeLoading = false;
        state.tradeError = action.payload;
      })

      // Trade Preference - Get My Preference
      .addCase(fetchMyTradePreference.pending, (state) => {
        state.tradeLoading = true;
        state.tradeError = null;
      })
      .addCase(fetchMyTradePreference.fulfilled, (state, action) => {
        console.log("Reducer got prefs:", action.payload);
        state.tradeLoading = false;
        state.myPreference = action.payload;
      })
      .addCase(fetchMyTradePreference.rejected, (state, action) => {
        state.tradeLoading = false;
        state.tradeError = action.payload;
      })

      // Trade Preference - Save/Update
      .addCase(saveTradePreference.pending, (state) => {
        state.tradeLoading = true;
        state.tradeError = null;
        state.tradeSuccess = null;
      })
      .addCase(saveTradePreference.fulfilled, (state, action) => {
        state.tradeLoading = false;
        state.tradeSuccess = "Trade preference saved successfully";
        state.myPreference = action.payload;
      })
      .addCase(saveTradePreference.rejected, (state, action) => {
        state.tradeLoading = false;
        state.tradeError = action.payload;
      })

      // Blogs Categories
      .addCase(getBlogsCategories.pending, (state) => {
        state.blogLoading = true;
        state.blogError = null;
      })
      .addCase(getBlogsCategories.fulfilled, (state, action) => {
        state.blogLoading = false;
        state.blogsCategories = action.payload;
      })
      .addCase(getBlogsCategories.rejected, (state, action) => {
        state.blogLoading = false;
        state.blogError = action.payload;
      })

      // Blogs List
      .addCase(getBlogsList.pending, (state) => {
        state.blogLoading = true;
        state.blogError = null;
      })
      .addCase(getBlogsList.fulfilled, (state, action) => {
        state.blogLoading = false;
        state.blogs = action.payload;
      })
      .addCase(getBlogsList.rejected, (state, action) => {
        state.blogLoading = false;
        state.blogError = action.payload;
      })

      // Blogs by Category
      .addCase(getBlogsByCategory.pending, (state) => {
        state.blogLoading = true;
        state.blogError = null;
      })
      .addCase(getBlogsByCategory.fulfilled, (state, action) => {
        state.blogLoading = false;
        state.blogs = action.payload;
      })
      .addCase(getBlogsByCategory.rejected, (state, action) => {
        state.blogLoading = false;
        state.blogError = action.payload;
      })

      // Blog Detail by Slug
      .addCase(getBlogDetailBySlug.pending, (state) => {
        state.blogLoading = true;
        state.blogError = null;
        state.blogDetail = {};
      })
      .addCase(getBlogDetailBySlug.fulfilled, (state, action) => {
        state.blogLoading = false;
        state.blogDetail = action.payload;
      })
      .addCase(getBlogDetailBySlug.rejected, (state, action) => {
        state.blogLoading = false;
        state.blogError = action.payload;
      })
      // Common Pages
      .addCase(getCommonPages.pending, (state) => {
        state.blogLoading = true;
        state.blogError = null;
      })
      .addCase(getCommonPages.fulfilled, (state, action) => {
        state.blogLoading = false;
        state.commonPages = action.payload;
      })
      .addCase(getCommonPages.rejected, (state, action) => {
        state.blogLoading = false;
        state.blogError = action.payload;
      })

      // Page Detail by Slug
      .addCase(getPageDetailBySlug.pending, (state) => {
        state.blogLoading = true;
        state.blogError = null;
      })
      .addCase(getPageDetailBySlug.fulfilled, (state, action) => {
        state.blogLoading = false;
        state.pageDetail = action.payload;
      })
      .addCase(getPageDetailBySlug.rejected, (state, action) => {
        state.blogLoading = false;
        state.blogError = action.payload;
      })

      // Site Map URLs
      .addCase(getSiteMapUrls.pending, (state) => {
        state.siteMapUrlLoading = true;
        state.siteMapUrlError = null;
      })
      .addCase(getSiteMapUrls.fulfilled, (state, action) => {
        state.siteMapUrlLoading = false;
        state.siteMapUrl = action.payload;
      })
      .addCase(getSiteMapUrls.rejected, (state, action) => {
        state.siteMapUrlLoading = false;
        state.siteMapUrlError = action.payload;
      })

      // Footer Links
      .addCase(getFooterLinks.pending, (state) => {
        state.footerLinksLoading = true;
        state.footerLinksError = null;
      })
      .addCase(getFooterLinks.fulfilled, (state, action) => {
        state.footerLinksLoading = false;
        state.footerLinks = action.payload;
      })
      .addCase(getFooterLinks.rejected, (state, action) => {
        state.footerLinksLoading = false;
        state.footerLinksError = action.payload;
      })

      // Price Exchange Rate
      .addCase(getPriceExchangeRate.pending, (state) => {
        state.priceExchangeRateLoading = true;
        state.priceExchangeRateError = null;
      })
      .addCase(getPriceExchangeRate.fulfilled, (state, action) => {
        state.priceExchangeRateLoading = false;
        state.priceExchangeRate = action.payload;
      })
      .addCase(getPriceExchangeRate.rejected, (state, action) => {
        state.priceExchangeRateLoading = false;
        state.priceExchangeRateError = action.payload;
      })

      // Ai Edit Image
      .addCase(editImage.pending, (state) => {
        state.editImageLoading = true;
        state.editImageError = null;
        state.editImageSuccess = null;
      })
      .addCase(editImage.fulfilled, (state, action) => {
        state.editImageLoading = false;
        state.editImageResult = action.payload.data?.edited_image || null;
        state.editImageSuccess = "Image edited successfully";
      })
      .addCase(editImage.rejected, (state, action) => {
        state.editImageLoading = false;
        state.editImageError = action.payload;
      })

      //Chart Data
      .addCase(marketCharts.pending, (state) => {
        state.chartLoading = true;
        state.chartError = null;
        state.chartSuccess = null;
      })
      .addCase(marketCharts.fulfilled, (state, action) => {
        state.chartLoading = false;
        state.chartData = action.payload;
        state.chartSuccess = "Chart Data successfully";
      })
      .addCase(marketCharts.rejected, (state, action) => {
        state.chartLoading = false;
        state.chartError = action.payload;
      })

      //News List
      .addCase(getNewsList.pending, (state) => {
        state.newsLoading = true;
        state.newsError = null;
        state.newsSuccess = null;
      })
      .addCase(getNewsList.fulfilled, (state, action) => {
        state.newsLoading = false;
        state.newsData = action.payload;
        state.newsSuccess = "News Data fetched successfully";
      })
      .addCase(getNewsList.rejected, (state, action) => {
        state.newsLoading = false;
        state.newsError = action.payload;
      })

      //Create Chat
      .addCase(chatCreation.pending, (state) => {
        state.createChatLoading = true;
        state.createChatError = null;
        state.createChatSuccess = null;
      })
      .addCase(chatCreation.fulfilled, (state, action) => {
        state.createChatLoading = false;
        state.createChatData = action.payload;
        state.createChatSuccess = true;
      })
      .addCase(chatCreation.rejected, (state, action) => {
        state.createChatLoading = false;
        state.createChatError = action.payload;
      })

      //Send Message
      .addCase(sendMessage.pending, (state) => {
        state.sendMessageLoading = true;
        state.sendMessageError = null;
        state.sendMessageSuccess = null;
      })
      .addCase(sendMessage.fulfilled, (state, action) => {
        state.sendMessageLoading = false;
        state.sendMessageData = action.payload;
        state.sendMessageSuccess = true;
        state.chatMessagesData.push(action.payload);
      })
      .addCase(sendMessage.rejected, (state, action) => {
        state.sendMessageLoading = false;
        state.sendMessageError = action.payload;
      })

      //Chat Messages
      .addCase(chatMessages.pending, (state) => {
        state.chatMessagesLoading = true;
        state.chatMessagesError = null;
      })
      .addCase(chatMessages.fulfilled, (state, action) => {
        state.chatMessagesLoading = false;
        state.chatMessagesData = action.payload;
        state.chatMessagesSuccess = true;
      })
      .addCase(chatMessages.rejected, (state, action) => {
        state.chatMessagesLoading = false;
        state.chatMessagesError = action.payload;
      })

      //Chat Threads
      .addCase(chatThreads.pending, (state) => {
        state.chatThreadsLoading = true;
        state.chatThreadsError = null;
      })
      .addCase(chatThreads.fulfilled, (state, action) => {
        state.chatThreadsLoading = false;
        state.chatThreadsData = action.payload;
        state.chatThreadsSuccess = true;
      })
      .addCase(chatThreads.rejected, (state, action) => {
        state.chatThreadsLoading = false;
        state.chatThreadsError = action.payload;
      })

      //Mark as Read
      .addCase(markAsRead.pending, (state) => {
        state.markAsReadLoading = true;
      })
      .addCase(markAsRead.fulfilled, (state, action) => {
        state.markAsReadLoading = false;
        state.markAsReadData = action.payload;
        state.markAsReadSuccess = true;
      })
      .addCase(markAsRead.rejected, (state, action) => {
        state.markAsReadLoading = false;
        state.markAsReadError = action.payload;
      })

      //Message Typing
      .addCase(typing.pending, (state) => {
        state.typingLoading = true;
      })
      .addCase(typing.fulfilled, (state, action) => {
        state.typingLoading = false;
        state.typingData = action.payload;
        state.typingSuccess = true;
      })
      .addCase(typing.rejected, (state, action) => {
        state.typingLoading = false;
        state.typingError = action.payload;
      })

      //Unread Count
      .addCase(unreadCount.pending, (state) => {
        state.unreadCountLoading = true;
      })
      .addCase(unreadCount.fulfilled, (state, action) => {
        state.unreadCountLoading = false;
        state.unreadCountData = action.payload?.count || 0;
        state.unreadCountSuccess = true;
      })
      .addCase(unreadCount.rejected, (state, action) => {
        state.unreadCountLoading = false;
        state.unreadCountError = action.payload;
      })

      //Dispute
      .addCase(dispute.pending, (state) => {
        state.disputeLoading = true;
      })
      .addCase(dispute.fulfilled, (state, action) => {
        state.disputeLoading = false;
        state.disputeData = action.payload;
        state.disputeSuccess = true;
      })
      .addCase(dispute.rejected, (state, action) => {
        state.disputeLoading = false;
        state.disputeError = action.payload;
      })

      //Create Support Chat
      .addCase(chatSupportCreation.pending, (state) => {
        state.createSupportChatLoading = true;
        state.createSupportChatError = null;
        state.createSupportChatSuccess = null;
      })
      .addCase(chatSupportCreation.fulfilled, (state, action) => {
        state.createSupportChatLoading = false;
        state.createSupportChatData = action.payload;
        state.createSupportChatSuccess = true;
      })
      .addCase(chatSupportCreation.rejected, (state, action) => {
        state.createSupportChatLoading = false;
        state.createSupportChatError = action.payload;
      })

      //Send Support Message
      .addCase(sendSupportMessage.pending, (state) => {
        state.sendSupportMessageLoading = true;
        state.sendSupportMessageError = null;
        state.sendSupportMessageSuccess = null;
      })
      .addCase(sendSupportMessage.fulfilled, (state, action) => {
        state.sendSupportMessageLoading = false;
        state.sendSupportMessageData = action.payload;
        state.sendSupportMessageSuccess = true;
        state.chatSupportMessagesData.push(action.payload);
      })
      .addCase(sendSupportMessage.rejected, (state, action) => {
        state.sendSupportMessageLoading = false;
        state.sendSupportMessageError = action.payload;
      })

      //Chat Support Messages
      .addCase(chatSupportMessages.pending, (state) => {
        state.chatSupportMessagesLoading = true;
        state.chatSupportMessagesError = null;
      })
      .addCase(chatSupportMessages.fulfilled, (state, action) => {
        state.chatSupportMessagesLoading = false;
        state.chatSupportMessagesData = action.payload;
        state.chatSupportMessagesSuccess = true;
      })
      .addCase(chatSupportMessages.rejected, (state, action) => {
        state.chatSupportMessagesLoading = false;
        state.chatSupportMessagesError = action.payload;
      })

      //Chat Support Threads
      .addCase(chatSupportThreads.pending, (state) => {
        state.chatSupportThreadsLoading = true;
        state.chatSupportThreadsError = null;
      })
      .addCase(chatSupportThreads.fulfilled, (state, action) => {
        state.chatSupportThreadsLoading = false;
        state.chatSupportThreadsData = action.payload?.data || [];
        state.chatSupportThreadsSuccess = true;
      })
      .addCase(chatSupportThreads.rejected, (state, action) => {
        state.chatSupportThreadsLoading = false;
        state.chatSupportThreadsError = action.payload;
      })

      //Mark Support as Read
      .addCase(markSupportAsRead.pending, (state) => {
        state.markSupportAsReadLoading = true;
      })
      .addCase(markSupportAsRead.fulfilled, (state, action) => {
        state.markSupportAsReadLoading = false;
        state.markSupportAsReadData = action.payload;
        state.markSupportAsReadSuccess = true;
      })
      .addCase(markSupportAsRead.rejected, (state, action) => {
        state.markSupportAsReadLoading = false;
        state.markSupportAsReadError = action.payload;
      })

      //Close Support Chat
      .addCase(closeSupportChat.pending, (state) => {
        state.closeSupportLoading = true;
      })
      .addCase(closeSupportChat.fulfilled, (state, action) => {
        state.closeSupportLoading = false;
        state.closeSupportData = action.payload;
        state.closeSupportSuccess = true;
      })
      .addCase(closeSupportChat.rejected, (state, action) => {
        state.closeSupportLoading = false;
        state.closeSupportError = action.payload;
      })

      //Switch Role
      .addCase(switchRole.pending, (state) => {
        state.roleSwitchLoading = true;
        state.roleSwitchError = null;
        state.roleSwitchSuccess = null;
      })
      .addCase(switchRole.fulfilled, (state, action) => {
        state.roleSwitchLoading = false;
        state.roleSwitch = action.payload;
        state.roleSwitchSuccess = "User role switched successfully";
      })
      .addCase(switchRole.rejected, (state, action) => {
        state.roleSwitchLoading = false;
        state.roleSwitchError = action.payload;
      })

      //Verify Role Otp
      .addCase(verifyRoleOtp.pending, (state) => {
        state.verifyRoleOtpLoading = true;
        state.verifyRoleOtpError = null;
        state.verifyRoleOtpSuccess = null;
      })
      .addCase(verifyRoleOtp.fulfilled, (state, action) => {
        state.verifyRoleOtpLoading = false;
        state.roleSwitch = action.payload;
        state.verifyRoleOtpSuccess =
          action.payload?.message || "Role OTP verified successfully";
      })
      .addCase(verifyRoleOtp.rejected, (state, action) => {
        state.verifyRoleOtpLoading = false;
        state.verifyRoleOtpError = action.payload;
      });
  },
});

export const {
  clearBuyerMessages,
  clearUserProfile,
  setCreateSupportChatData,
  resetAddressStatus,
  addSupportMessage,
} = userSlice.actions;
export default userSlice.reducer;
